"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.populate = void 0;
const isNotNull = (video) => video.hls !== null;
/**
 * Generates a key value lookup table with URL paths as keys and video metadata as values. Used for populating
 * meta tags in the <head> of the HTML document for SEO purposes.
 *
 * @param metadata A partially complete lookup table of meta tags to populate
 * @param translation A CBT translation object
 */
const populate = (metadata, translation) => {
    const code = translation.translation_shortcode;
    const author = translation.team.name;
    translation.stories.forEach((storyGroup) => {
        storyGroup.videos.filter(isNotNull).forEach((video) => {
            var _a, _b, _c, _d;
            const key = `/${code}/${storyGroup.slug}/${video.type}`.toLowerCase();
            const title = `${code.toUpperCase()} | ${(_b = (_a = storyGroup.title) !== null && _a !== void 0 ? _a : storyGroup.title_english) !== null && _b !== void 0 ? _b : ""}`;
            const description = (_d = (_c = storyGroup.subtitle) !== null && _c !== void 0 ? _c : storyGroup.subtitle_english) !== null && _d !== void 0 ? _d : "";
            const thumbnailUrl = storyGroup.thumbnail_image_url;
            const value = { title, author, description, thumbnailUrl };
            metadata[key] = value;
        });
    });
};
exports.populate = populate;
